"use strict";

// NPM modules

var moment = require('moment');
var debug = false;

let {
	holidays,
	maxDate,
	minDate,
} = require('./holidays.js');

// Function

module.exports = function prevBizDay(startDate, bizDaysPrior) {

	if (! startDate) return 'invalid';	
	if (! bizDaysPrior) return 'Usage: prevBizDays(<date to start with>, <how many days prior>)';	
	
	var startDateMoment = moment(startDate).startOf('day');
	if (! startDateMoment.isValid()) return 'invalid';
	
	if (startDateMoment.isAfter(maxDate)) {
		if (debug) console.log("*** Invalid date: %s (Out of maximum range!)", startDateMoment.format("YYYY-MM-DD"));
		return 'invalid';
	}

	if (startDateMoment.isBefore(minDate)) {
		if (debug) console.log("*** Invalid date: %s (Out of minimum range!)", startDateMoment.format("YYYY-MM-DD"));
		return 'invalid';
	}
	
	// test to see if this day is a valid business day. If it is not, advance by one day. if it is, return the value.
	var days = 0;
	
	startDateMoment.subtract(bizDaysPrior, 'd');

	while (1) {
		
		var dayOfWeek = startDateMoment.day();
		if ((dayOfWeek > 0) && (dayOfWeek < 6) && (! holidays[startDateMoment.format("YYYY-MM-DD")])) {
			return startDateMoment.toDate();
		}
		
		startDateMoment.subtract(1, 'd');

		days += 1;
		if (days > bizDaysPrior) {
			if (debug) console.log("*** BizDays greater than %s", bizDaysPrior);
			return 'invalid';
		}
		
	}

}




